import If from "../../../if"
import { PartialLoader } from "../../../skeletons"
import { useFetchSubscriptionDetailsQuery } from "../../../../../redux/queries"
import { SubscriptionLog } from "../../../../../types"

interface Props {
  info: SubscriptionLog
}

const ViewDashboardCell: React.FC<Props> = ({ info }) => {
  const { data } = useFetchSubscriptionDetailsQuery({ id: info.id })

  return (
    <td className="view-dashboard-cell relative whitespace-nowrap py-4 px-0 text-right text-sm cursor-pointer sm:pr-6 pl-3 md:pr-4 hidden md:table-cell">
      <If
        condition={!data}
        then={<PartialLoader className="w-24" />}
        else={
          data?.dashboard_link ? (
            <a
              className="pb-1 border-b border-dotted border-neutral-400  invisible group-hover:visible"
              href={data.dashboard_link}
              target="_blank"
              rel="noreferrer"
            >
              View dashboard
            </a>
          ) : null
        }
      />
    </td>
  )
}
export default ViewDashboardCell
